import React from "react";

import FormComponent from "./Form";
import { defaultSettings } from "./defaults/settings";

const createPlugin = (settings) => {
    const mergedSettings = { ...defaultSettings, ...settings };

    const { Component } = mergedSettings;

    return {
        Component: (props) => <Component {...props} {...mergedSettings} />,
        FormComponent: (props) => (
            <FormComponent {...props} {...mergedSettings} />
        ),

        name: "keylite/content/flat-roof-hero-banner",
        version: "1.0.0",
        text: mergedSettings.translations.pluginName,
        description: mergedSettings.translations.pluginDescription,
        IconComponent: mergedSettings.IconComponent,
        createInitialState: () => ({
            title: "Flat Roof Solutions",
            text: "",
            buttonText: "Build & Buy",
            image: "https://assets.keyliteroofwindows.pub/images/Flat%20Roof%20Window%20Solutions/KYLRW%20-%20Hero%20Image%20(23).jpg",
            imageAlt: "Flat Roof Solutions",
        }),
    };
};

export default createPlugin;
